// AddressForm.jsx
import React, { useState, useRef, useEffect } from 'react';
import { getSecrets } from "../api/secrets";
import { ReactComponent as SearchIcon } from '../assets/icons/top_nav/search.svg';

// This component is to handle address input, submit, and geocoding
const AddressForm = ({ label, defaultStatus, addMarker, inputValue, onInputChange}) => {
  const [address, setAddress] = useState('');
  const [suggestions, setSuggestions] = useState('');
  const [searchStatus, setSearchStatus] = useState(inputValue==='' ? true : false);
  const [currentLocation, setCurrentLocation ] = useState(false);
  const [apiKey, setApiKey] = useState(""); // Store ORS API key

  const inputRef = useRef(null);
  // here map api parameters

  useEffect(() => {
    // Fetch the ORS API Key securely
    async function fetchSecrets() {
      const secrets = await getSecrets();
      if (secrets && secrets.OpenRouteService) {
        setApiKey(secrets.OpenRouteService);
      } else {
        console.error("Error: OpenRouteService API key not found!");
      }
    }
    fetchSecrets();
  }, []);

  useEffect(()=>{
    // when it is the input field for origin address and it is empty, take user's current location
    if (label==='Origin' && inputValue.length === 0){ 
      if (navigator.geolocation){
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setCurrentLocation(true);
            // disable the magnifier button
            setSearchStatus(false);
            // make maker based on current location
            const newMarker = { address: ["Your location"], position: [ latitude, longitude ] };   // switch lat lon position to create marker
            addMarker(newMarker);
          },
          (error) => {
            console.error('Error getting current location:', error);
          }
        );
      }
    }
    
  },[]);
  // handling  change in the address input field
  const handleChange = (event) => {
    const inputText = event.target.value;
    setAddress(inputText);
    onInputChange(inputText);
    fetchSuggestions(inputText);
    // when user want to change input value, set currentLocation back to false to ban it
    setCurrentLocation(false);
    
    if (inputText =='') {
      // show the search (magnifier) when the input field is empty
      setSearchStatus(true);
      // turn off the autocomplete list when the input field is empty
      setSuggestions([])
      // remove marker
      addMarker(null);     
    }
  }

  const fetchSuggestions = async (inputText) => {
    if (!apiKey) {
      console.error("API key not loaded yet.");
      return;
    }
    try {
      const response = await fetch(
        `https://api.openrouteservice.org/geocode/autocomplete?api_key=${apiKey}&boundary.rect.min_lon=11.41&boundary.rect.min_lat=48.05&boundary.rect.max_lon=11.66&boundary.rect.max_lat=48.24&boundary.country=DE&text=${inputText}`
      );
      const data = await response.json();
      setSuggestions(data.features || []);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  }; 

  // function to handle user click on autocomplete address list
  const handleSuggestionClick = (suggestion) => {
    
    // Handle the selection of a suggestion
    const newPosition = suggestion.geometry.coordinates;
   
    // address info of marker. idealy the address contains: place name, street name, street no., and postalcode 
    const address_info = [suggestion.properties.name, suggestion.properties.street, suggestion.properties.housenumber, suggestion.properties.postalcode]
    // create marker based on selected address
    const newMarker = { address: address_info, position: [newPosition[1],newPosition[0]] };   // switch lat lon position to create marker
    addMarker(newMarker);

    // set new address, and turn off the address list and search button
    setAddress(suggestion.properties.label);
    setSuggestions([]);
    setSearchStatus(false);

    // Update the input value with the selected suggestion
    onInputChange(suggestion.properties.label)

  };

  // Geocode search function
  const geoSearch = async (address) => {
    if (!apiKey) {
      console.error("API key not loaded yet.");
      return;
    }
    try {
      const response = await fetch(
        `https://api.openrouteservice.org/geocode/search?api_key=${apiKey}&text=${address}&boundary.rect.min_lon=11.41&boundary.rect.min_lat=48.05&boundary.rect.max_lon=11.66&boundary.rect.max_lat=48.24&boundary.country=DE`
      );
      const data = await response.json();
      setSuggestions([]);
      if (data && data.features.length > 0) {
        const result = data.features[0];
        const newPosition = [result.geometry.coordinates[1], result.geometry.coordinates[0]];
        const address_info = [
          result.properties["name"],
          result.properties["street"],
          result.properties["housenumber"],
          result.properties["postalcode"],
        ];
        const newMarker = { address: address_info, position: newPosition };
        addMarker(newMarker);
        setSearchStatus(false);
      } else {
        console.error("Geocoding failed. Please enter a valid address.");
      }
    } catch (error) {
      console.error("Error during geocoding:", error);
    }
  };
  
  // implement when user press "enter" button after address input
  const handleSubmit = async(event, address)=> {
    if (event.key === 'Enter') {
      geoSearch(address);
    }
  }
  // implement when user press the magn
  const searchButtonClick = (address) => {
    geoSearch(address);
  }

  return (
    <div className="text-input-container">
      {searchStatus && (
        <button className="search-icon" onClick={() => searchButtonClick(address)}>
        
          <SearchIcon></SearchIcon>
        </button>
      )}

      <input
        type="text"
       
        value={(currentLocation && defaultStatus) ? 'Your location' : inputValue}
        placeholder="Search"
        className="text-input"
        onChange={handleChange}
        onKeyDown={(event) => handleSubmit(event, address)}
        ref={inputRef}
      />
      {label === 'origin' && (
        <button className="current-location-button" >
          Use Current Location
        </button>
      )}

      {/* Display autocomplete suggestions--- cut at 5 suggestions */}
      {suggestions.length > 0 && (
        <ul className='suggestion-list'>
          {suggestions.slice(0, 5).map((suggestion) => (
            <li key={suggestion.properties.label} onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion.properties.label}
            </li>
          ))}
        </ul>
      )}
    </div>

  );
};

export default AddressForm;
